import { CurrencyInput, EInputTypes, InputTextCustom } from "medere-ui-framework";
import { useState, useEffect } from "react";

interface BudgetBodyComponentProps {
    CRUDBehaviour:boolean;
    inputType?: EInputTypes;
    inputClassName?: string;
    pClassName?:string;
    value: any;
    pValue?:any
    onChange: (e: any) => void;
    currency?: boolean;
    disable?: boolean;
    min?: number;
}


export const BudgetBodyComponent = ({ CRUDBehaviour, inputType=EInputTypes.NUMBER, inputClassName="", pClassName="", value, pValue, onChange, currency=false, disable=false, min}:BudgetBodyComponentProps) => {
    const [initialValue, setInitialValue] = useState<any>(null);
    const [flag, setFlag] = useState<boolean>(true);

    useEffect(() => {
        if (flag && value && value !== 0) 
            setInitialValue(value);
        setFlag(true);
    }, [value, initialValue]);

    if (CRUDBehaviour) {
        if(currency)
            return <CurrencyInput ammount={value} setAmmount={(e)=>{
                setFlag(false);
                onChange(e);
            }} defaultAmmount={initialValue} disable={disable}/> 
        return (
        <InputTextCustom
            value={value}
            defaultValue={initialValue}
            inputType={inputType}
            inputClassName={inputClassName}
            onChange={(e)=>{
                setFlag(false);
                onChange(e);
            }}
            disable={disable}
            min={min}
        />
        );
    }

    return <p className={pClassName}>{pValue ?? value}</p>;
};
